module.exports = __webpack_public_path__ + "images/emoji/bangbang.2a3abe5dbcd0cdb40ed8.png";